import {
  dimensiondata_1_fogyasztasi_sav_group_w300_row,
  dimensiondata_2_adozasi_szint_group_column,
  halfYear_row_expanded,
  huf_gigajoule_brutto_value_1_data_precision_no_year_half_year_summary,
  huf_gigajoule_netto_value_2_data_precision_no_year_half_year_summary,
  huf_kilowatt_ora_value_3_data_precision_no_year_half_year_summary,
  year_row_expanded,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const foldgazLakossagiArakConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/FoldgazLakossagiArak',
      select: ['date', 'dimension_1', 'dimension_2', 'value_1', 'value_2', 'value_3'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      year_row_expanded,
      halfYear_row_expanded,
      ...dimensiondata_1_fogyasztasi_sav_group_w300_row,
      ...dimensiondata_2_adozasi_szint_group_column,
      huf_gigajoule_brutto_value_1_data_precision_no_year_half_year_summary,
      huf_gigajoule_netto_value_2_data_precision_no_year_half_year_summary,
      huf_kilowatt_ora_value_3_data_precision_no_year_half_year_summary,
      order_1,
      order_2
    ],
  },
};
